import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import classes from "./afterloginheader.module.css";
import SearchResultCss from "../../Pages/StudentFlow/SearchResults/SearchResults.module.css";
import CallMadeIcon from "@mui/icons-material/CallMade";
import { Col, Container, Row } from "react-bootstrap";
import {
  ArrowUpRightBlue,
  bookingIcon,
  favoriteIcon,
  logoColor,
  messageIcon,
  notificationIcon,
} from "../../constant/imagePath";
import { Popover } from "@mui/material";

// import { BsChatDots } from "react-icons/bs";
// import { BiBell } from "react-icons/bi";
// import { BsHeart } from "react-icons/bs";
import { IoCalendarClearOutline, IoSearchSharp } from "react-icons/io5";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";

import Tooltip from "react-bootstrap/Tooltip";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import { NameAvatar } from "../NameAvatar/NameAvatar";
import useClickOutsideHook from "../../CustomHooks/useClickOutsideHook";
import { SearchBar } from "../SearchBar/SearchBar";
import Fonts from "../assets/Fonts";
import { ClickAwayListener } from "@mui/material";
import { NotificationBox } from "../../stories/NotificationBox/NotificationBox";
import Colors from "../assets/Colors";
import { useHistory } from "react-router-dom";

function NotificationPopup({ anchorEl, setAnchorEl }) {
  const history = useHistory();
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <style>
        {`.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8{
            border-radius:10px;
            margin-top:8px
        }
        `}
      </style>
      <Popover
        id={id}
        className={classes.main}
        style={{ marginTop: "20px", borderRadius: "20px" }}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "right",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "right",
          horizontal: "right",
        }}
      >
        <div className={classes.notificationsBox}>
          {["", "", "", "", "", "", "", "", ""]?.map((item) => {
            return (
              <div>
                <NotificationBox
                  customStyle={{
                    margin: "0px",
                    border: "none",
                    paddingBottom: "0px",
                  }}
                />
              </div>
            );
          })}
        </div>
        {/* Mark As read */}
        <div
          style={{ background: Colors.neutralShadesOfWhiteSmoke }}
          className={classes.markAndView}
        >
          <span style={{ ...Fonts.b2, color: Colors.neutralShadesOfDimGray }}>
            Mark all as read
          </span>

          <LinkButtonWithIcon
            text={"View all notifications"}
            primary={true}
            onClick={() => history.push("/student-notifications")}
          />
        </div>
      </Popover>
    </div>
  );
}

export const AfterLoginHeader = ({
  icon,
  showSearch,
  onClickSearch,
  onSubmitSearch,
  onClickGetAMatch,
  customStyle,
  user,
  isWhite,
  className,
  getAMatchIcon,
}) => {
  const history = useHistory();
  const [isHoverOn, setIsHoverOn] = useState(false);
  const [headerRef] = useClickOutsideHook(() => {
    console.log("useClickOutsideHookRun");
    // if (isHoverOn == true) {
    //   setIsHoverOn(false);
    //   onClickSearch && onClickSearch("");
    // }
  });
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  // For Notification Popup state
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (headerRef.current) {
      setDimensions({
        width: headerRef?.current?.offsetWidth,
        height: headerRef?.current?.offsetHeight,
      });
    }
  }, [isHoverOn]);

  const handleSubmitSearch = (data) => {
    setIsHoverOn(false);
    onClickSearch && onClickSearch("");
    onSubmitSearch(data);
  };
  const handleClickAway = () => {
    if (isHoverOn == true) {
      setIsHoverOn(false);
      onClickSearch && onClickSearch("");
    }
  };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container
        fluid
        className={`${[
          classes.AfterLoginHeader,
          isHoverOn && classes.whiteContainer,
          className,
        ].join(" ")}`}
        ref={headerRef}
        style={customStyle}
      >
        <style jsx>{`
          .tooltip-inner {
            padding: 8px;
            // padding: 0.6rem;
            color: #fff;
            background-color: #222222;
            border-radius: 10px;
          }
          .${classes.whiteContainer}::after {
            height: ${dimensions?.height}px;
          }
          .${classes.icons} {
            filter: ${isWhite &&
            "invert(100%) sepia(0%) saturate(24%) hue-rotate(114deg) brightness(108%) contrast(108%)"};
          }
        `}</style>

        <Row>
          <Col md={12} className={[classes.wrapper].join(" ")}>
            <div className={classes.innerCol1}>
              <img
                src={icon}
                alt=""
                className={[classes.logoImage].join(" ")}
              />
            </div>
            <div className={[classes.innerCol2].join(" ")}>
              {!isHoverOn && showSearch && (
                <div
                  className={`${[classes.innerCol2SubContainer].join(" ")}`}
                  onClick={() => {
                    onClickSearch &&
                      onClickSearch(
                        isHoverOn ? "" : SearchResultCss?.customOverLay
                      );
                    onClickSearch && setIsHoverOn(!isHoverOn);
                  }}
                >
                  <span>Search</span>
                  <span className={`${[classes.beforeContainer].join(" ")}`}>
                    Add Date
                  </span>
                  <span className={`${[classes.beforeContainer].join(" ")}`}>
                    Add Location
                  </span>
                  <div className={`${[classes.arrowContainer].join(" ")}`}>
                    <IoSearchSharp color="white" />
                  </div>
                </div>
              )}
            </div>
            <div className={[classes.innerCol3].join(" ")}>
              {/* <Row> */}
              {/* <Col md={12}> */}
              <div className={`${[classes.linkContainer].join(" ")}`}>
                <LinkButtonWithIcon
                  customStyle={{
                    ...Fonts.b2,
                    width: "max-content",
                    // marginRight: "32px",
                    lineHeight: "20px",
                  }}
                  text={"Get A Match"}
                  className={classes.getAMatch}
                  primary={true}
                  isWhite={isWhite && true}
                  // onClick={onClickGetAMatch}
                  onClick={() => history.push("/get-a-match")}
                  rightIcon={getAMatchIcon ? getAMatchIcon : ArrowUpRightBlue}
                  iconStyle={{ marginLeft: "0px" }}
                />
                <OverlayTrigger
                  key={"bookings"}
                  placement="bottom"
                  overlay={
                    <Tooltip
                      id={` ${[classes.tooltip].join(" ")}`}
                      className={` ${[classes.tooltip].join(" ")}`}
                    >
                      my lessons
                    </Tooltip>
                  }
                >
                  <img
                    src={bookingIcon}
                    alt=""
                    className={` ${[classes.icons].join(" ")}`}
                    onClick={() => history.push("/student-dashboard")}
                  />
                </OverlayTrigger>

                <OverlayTrigger
                  key={"favorite"}
                  placement="bottom"
                  overlay={
                    <Tooltip
                      id={` ${[classes.tooltip].join(" ")}`}
                      className={` ${[classes.tooltip].join(" ")}`}
                    >
                      favorite
                    </Tooltip>
                  }
                >
                  <img
                    src={favoriteIcon}
                    alt=""
                    className={[classes.icons].join(" ")}
                    onClick={() => history.push("/student-flow-favorites")}
                  />
                </OverlayTrigger>
                <OverlayTrigger
                  key={"notifications"}
                  placement="bottom"
                  overlay={
                    <Tooltip
                      id={` ${[classes.tooltip].join(" ")}`}
                      className={` ${[classes.tooltip].join(" ")}`}
                    >
                      notifications
                    </Tooltip>
                  }
                >
                  <>
                    <img
                      src={notificationIcon}
                      alt=""
                      className={[classes.icons].join(" ")}
                      onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                      }}
                    />
                  </>
                </OverlayTrigger>
                {/* NotificationBox */}
                <NotificationPopup
                  setAnchorEl={setAnchorEl}
                  anchorEl={anchorEl}
                />
                {/* NotificationBox */}
                <OverlayTrigger
                  key={"messages"}
                  placement="bottom"
                  overlay={
                    <Tooltip
                      id={` ${[classes.tooltip].join(" ")}`}
                      className={` ${[classes.tooltip].join(" ")}`}
                    >
                      messages
                    </Tooltip>
                  }
                >
                  <img
                    src={messageIcon}
                    alt=""
                    className={[classes.icons].join(" ")}
                    onClick={() => history.push("/student-chat")}
                  />
                </OverlayTrigger>

                {/* <IoCalendarClearOutline />
                <BsHeart />
                <BiBell />
                <BsChatDots /> */}
                <NameAvatar
                  isAllowDropDown={true}
                  userName={user?.userName}
                  size={"36px"}
                />
              </div>
              {/* </Col> */}
              {/* </Row> */}
            </div>
          </Col>
          {isHoverOn && (
            <Col
              md={12}
              className={[classes.innerColSearchContainer].join(" ")}
            >
              <SearchBar onSubmitSearch={handleSubmitSearch} />
            </Col>
          )}
        </Row>
      </Container>
    </ClickAwayListener>
  );
};

AfterLoginHeader.propTypes = {
  icon: PropTypes.string,
  showSearch: PropTypes.bool,
  onClickSearch: PropTypes.func,
  onSubmitSearch: PropTypes.func,
  onClickGetAMatch: PropTypes.func.isRequired,
  getAMatchIcon: PropTypes.string,
};

AfterLoginHeader.defaultProps = {
  icon: logoColor,
  showSearch: false,
  user: {
    userName: "Harry Mat",
  },
};
